export default "__VITE_ASSET__CuA$cVl1__"